/* Herbal Vitaly — locale-aware internal routing safety layer.
   Uses Shopify.routes.root; does nothing on the primary root locale. */
(function () {
  'use strict';

  var rawRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
  if (!rawRoot) return;

  function normalizeRoot(value) {
    var path;
    try {
      path = new URL(String(value), window.location.origin).pathname || '/';
    } catch (error) {
      path = String(value || '/');
    }
    if (path.charAt(0) !== '/') path = '/' + path;
    path = path.replace(/\/{2,}/g, '/');
    if (path.charAt(path.length - 1) !== '/') path += '/';
    return path;
  }

  var localizedRoot = normalizeRoot(rawRoot);
  if (localizedRoot === '/') return;

  var localePrefix = localizedRoot.slice(0, -1);
  var routeSegments = ['collections', 'products', 'pages', 'cart', 'search', 'blogs', 'policies'];

  function isStorefrontRoute(pathname) {
    return routeSegments.some(function (segment) {
      return pathname === '/' + segment || pathname.indexOf('/' + segment + '/') === 0;
    });
  }

  function normalizeInternalPath(pathname) {
    var path = String(pathname || '/').replace(/\/{2,}/g, '/');

    /* Remove accidental duplicate locale prefixes such as /en/en/.... */
    var duplicatePrefix = localePrefix + localePrefix + '/';
    while (path.indexOf(duplicatePrefix) === 0) {
      path = path.slice(localePrefix.length);
    }

    /* Already correctly localized. */
    if (path === localePrefix || path.indexOf(localePrefix + '/') === 0) return path;

    /* Repair malformed concatenation such as /encollections/... or /enpages/.... */
    for (var index = 0; index < routeSegments.length; index += 1) {
      var segment = routeSegments[index];
      var malformed = localePrefix + segment;
      if (path === malformed || path.indexOf(malformed + '/') === 0) {
        path = '/' + path.slice(localePrefix.length);
        break;
      }
    }

    if (!isStorefrontRoute(path)) return pathname;
    return localizedRoot + path.replace(/^\/+/, '');
  }

  function localizeAnchor(anchor) {
    if (!anchor || !anchor.getAttribute) return;
    var rawHref = anchor.getAttribute('href');
    if (!rawHref || rawHref.charAt(0) === '#' || /^(mailto:|tel:|sms:|javascript:|data:)/i.test(rawHref)) return;

    var url;
    try {
      url = new URL(rawHref, window.location.origin);
    } catch (error) {
      return;
    }

    if (url.origin !== window.location.origin) return;

    var normalizedPath = normalizeInternalPath(url.pathname);
    if (normalizedPath === url.pathname) return;

    anchor.setAttribute('href', normalizedPath + url.search + url.hash);
  }

  function scan(root) {
    if (!root) return;
    if (root.nodeType === 1 && root.matches && root.matches('a[href]')) localizeAnchor(root);
    if (root.querySelectorAll) root.querySelectorAll('a[href]').forEach(localizeAnchor);
  }

  function init() {
    scan(document);
    if (!window.MutationObserver) return;
    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) scan(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();

/* Herbal Vitaly — direct localized Return & Refund Policy footer links. */
(function () {
  'use strict';

  function updateReturnPolicyFooterLink() {
    var footer = document.querySelector('.hv7-footer');
    if (!footer) return;

    var isEnglish = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0 ||
      window.location.pathname === '/en' || window.location.pathname.indexOf('/en/') === 0;
    var isFrench = String(document.documentElement.lang || '').toLowerCase() === 'fr';
    var target = isFrench ? '/fr/pages/return-refund-policy' : (isEnglish ? '/en/pages/return-refund-policy' : '/pages/return-refund-policy');

    footer.querySelectorAll('a[href="/policies/refund-policy"], a[href="/en/policies/refund-policy"]').forEach(function (anchor) {
      anchor.setAttribute('href', target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateReturnPolicyFooterLink, { once: true });
  } else {
    updateReturnPolicyFooterLink();
  }
})();

